document.addEventListener('DOMContentLoaded', () => {

  // *************************
  // Collection infinite loading
  // Load more products with the load more button beneath the pagination on a PLP
  // *************************
  function loadMoreProducts() {

    const loadMoreURL = document.querySelector('[data-load-more] a').getAttribute('href');
    const pagingEl = document.querySelector('[data-paging]');

    // add display none check after
    if (loadMoreURL.length > 0) {
      // Hide the paging element while we load in the new content
      pagingEl.classList.add('opacity-0');
      fetch(loadMoreURL)
      .then(response => response.text())
      .then(responseText => {
        // Parse the response text
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        // Get the product cards from the next page
        const filteredData = html.querySelectorAll('[data-collection-list] [data-collection-item]');
        // Append these cards to the main collection list
        filteredData.forEach(item => {
          document.querySelector('[data-collection-list]').append(item);
        });

        // Update the paging area
        const pagingData = html.querySelector('[data-paging]');
        
        if (pagingData){
          pagingEl.innerHTML = pagingData.innerHTML;
        } else {
          pagingEl.classList.add('hidden');
        }

        // Reveal the paging element again
        pagingEl.classList.remove('opacity-0');

      })
      .catch(e => {
        console.error(e);
      });
    }
  }

  document.addEventListener('click', (event) => {
    const loadMoreButton = event.target.closest('[data-load-more] a');
    if (loadMoreButton) {
      event.preventDefault();
      loadMoreProducts();
      return false;
    }
  });


  document.addEventListener('click', (event) => {

    // clicked on a product card from the PLP?
    const dataEl = event.target.closest('[data-collection-product-item]');
    if (dataEl) {
      // get the page content
      let productGrid = document.getElementById("ProductGridContainer").innerHTML;
      
      // get the current location and scroll
      const 
        location = window.location.href,
        scroll = window.scrollY;
        
      window.history.pushState({data: productGrid, name: 'listing-grid', scroll: scroll}, '', location);
      
    }
  });

  // if (window.history && window.history.pushState) {
  //   if (window.history.state && (window.history.state.name == 'listing-grid') && document.getElementById("product-grid")) {
  //     document.getElementById("ProductGridContainer").innerHTML = window.history.state.data;
  //   }
  // }


  function showIncompleteFinalRowItems() {
    const elements = document.querySelectorAll('[data-collection-item]');

    elements.forEach((element) => {
      element.classList.remove('hidden');
    });
  }

  // Function to detect the final row and select items if there are fewer than 4
  function selectIncompleteFinalRowItems() {
      
    // Select the grid container and items
    const gridContainer = document.querySelector('#product-grid');

    // Select the grid container and its items
    const gridItems = Array.from(gridContainer.children);

      showIncompleteFinalRowItems();

      if (!gridContainer || gridItems.length === 0) return;

      // Create a map to store items grouped by their row position
      const rows = new Map();

      gridItems.forEach((item) => {
          // Get the top position of the item relative to the grid container
          const itemTop = item.getBoundingClientRect().top;

          // Use the top position as the key to group items into rows
          if (!rows.has(itemTop)) {
              rows.set(itemTop, []);
          }
          rows.get(itemTop).push(item);
      });

      // Get all rows as an array of items
      const rowArray = Array.from(rows.values());

      // Get the final row
      const finalRow = rowArray[rowArray.length - 1];

      // Check if the final row has fewer than 4 items
      if (finalRow.length > 0 && finalRow.length < 4) {
          finalRow.forEach((item) => {
              item.classList.add('hidden');
          });
      }

      const visibleProducts = document.querySelectorAll('[data-collection-product-item]:not(.hidden)');
      document.getElementById('pagingCurrentCount').textContent = visibleProducts.length;
  }

  // Run the function
  const pagingData = document.querySelector('[data-paging]');
  if (pagingData){
    selectIncompleteFinalRowItems();
  }

  // PLP Sorting trigger
  // Clicking "SORT BY: <option>" should open filters drawer + expand Sort by
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-plp-sort-trigger]');
    if (!trigger) return;

    event.preventDefault();

    const sectionId = trigger.getAttribute('data-section-id');
    const dialogComponent = document.getElementById('filters-drawer');

    if (dialogComponent && typeof dialogComponent.showDialog === 'function') {
      dialogComponent.showDialog();
    }

    // Wait a tick for dialog to be open before expanding details
    window.setTimeout(() => {
      if (!sectionId) return;

      const sortDetails = document.querySelector(
        `#filters-drawer #Sorting-${CSS.escape(sectionId)}`
      );

      if (sortDetails instanceof HTMLDetailsElement) {
        sortDetails.open = true;
        sortDetails.scrollIntoView({ block: 'start' });
      }
    }, 50);
  });

});
